import logoNoronCar from '../Images/logo.png'
import config from "../config.json";
import "./Register.css";
import loginLogo from '../Images/logoWeb.png'
import AddImage from '../Images/AddImage.png'
import React, { useContext, useEffect, useState, useRef } from "react";

import { Link } from 'react-router-dom';
import http from "../Services/httpService";
import service from "../Services/services";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';

export default function Register() {
    let navigate = useNavigate();
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            Username: "", Password: ""
            , Company: config.Company
            , Year: config.Year
            , verision: config.Version
        });
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (jwt && jwt != "") {
            navigate('/main');
        }
        return () => { }
    }, []);

    const backgroundCardMeli = useRef(null);
    const picCardMeli = useRef(null);

    const backgroundCode = useRef(null);
    const picCode = useRef(null);

    const backgroundMovafegh = useRef(null);
    const picMovafegh = useRef(null);

    const backgroundPersoneli = useRef(null);
    const picPersoneli = useRef(null);

    //backgroundCardMeli.current.style.backgroundImage = `url(${config.apiUrl}/PicReseller/cardMeli/${data.payload.id}.jpg?${new Date().getTime()})`;
    const upload = (e, background, name) => {
        const { files } = e.target;
        if (files.length === 0) {
            return;
        }
        if (background) {
            const fileReader = new FileReader();
            fileReader.onload = () => {
                //style={{ backgroundImage: `url(${travelDetailPic})` }}            
                background.current.style.backgroundImage = `url(${fileReader.result})`;
            };
            fileReader.readAsDataURL(files[0]);
        }
        setForm({ ...form, [name]: e.target.files[0] })
    }
    const formRef = useRef(null);
    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await service.OzveRegister(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                //toast.dark("اطلاعات شما ثبت شد و جهت بررسی و تائید به کارشناس مربوطه ارجاع شد")
                //navigate(`/login`);
                toast.dark('لطفا تا انتقال به درگاه بانک شکیبا باشید');
                window.location = data.payload;
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    return (
        <>
            <div className="container  d-flex align-items-center justify-content-center">
                <div className="w-100">
                    <div className="row mt-2 ">
                        <div className="col d-flex  justify-content-center">
                            <img src={loginLogo} className="img-fluid logoRegister" alt="logoRegister" />
                        </div>
                    </div>
                    <div className="row mt-3 ">
                        <div className="col fs-5 text-color1 fw-bold d-flex  justify-content-center">
                            ثبت نام کانون بازنشستگان همدان
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col'>
                            <div className="alert alert-primary" role="alert">
                                <h4 className="alert-heading">توجه</h4>
                                فقط افرادی مجاز به ثبت نام و عضویت در این کانون می باشند که در یکی از شعب یک، دو یا سه تامین اجتماعی همدان یا فامنین بازنشسته شده باشند
                            </div>
                        </div>
                    </div>
                    <form ref={formRef} className=" needs-validation" >
                        <div className="row mt-3">
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">کد ملی</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.codeMeli}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="codeMeli" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">شماره موبایل</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.mobile}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="mobile" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">شماره مستمری</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.mostamariCode}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="mostamariCode" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">نام</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.name}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="name" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">نام خانوادگی</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.family}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="family" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">نام پدر</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.nameFather}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="nameFather" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">شماره شناسنامه</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.code}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="code" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">سریال شناسنامه</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.seriall}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="seriall" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">تاریخ تولد</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.birthDay}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="birthDay" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">تلفن ثابت</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.telfix}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="telfix" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">آدرس</label>
                                    <textarea
                                        rows="3"
                                        className="form-control"
                                        placeholder=""
                                        required
                                        value={form.address}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="address" />
                                </div>
                            </div>
                            <div className="col-auto">
                                <div className="mb-3">
                                    <label className="form-label">شعبه</label>
                                    <select
                                        className="form-select"
                                        required
                                        value={form.mostameriShobeh}
                                        onChange={e => http.handleChange(e, form, setForm)}
                                        name="mostameriShobeh" >
                                        <option value="">انتخاب کنید</option>
                                        <option value="1">1- همدان بوعلی</option>
                                        <option value="2">2- همدان - امام زاد عبدالله</option>
                                        <option value="3">3- همدان - میرزاده عشقی - تالارحافظ</option>
                                        <option value="4">4- فامنین</option>                                        
                                    </select>
                                </div>
                            </div>
                            <div className='col-auto border rounded m-2   '
                                style={{ backgroundSize: "cover" }}
                                ref={backgroundPersoneli}>
                                <input
                                    accept="image/*"
                                    className="d-none"
                                    type="file"
                                    onChange={(e) => { upload(e, backgroundPersoneli, "personeliPic") }}
                                    ref={picPersoneli}
                                />
                                <div className='row p-4 '>
                                    <div className='col justify-content-center align-items-center text-center' >
                                        <div>
                                            <Link
                                                to=""
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    picPersoneli.current.click()
                                                }}>
                                                <img src={AddImage} />
                                            </Link>
                                        </div>
                                        عکس پرسنلی
                                    </div>
                                </div>
                            </div>

                            <div className='col-auto border rounded m-2   '
                                style={{ backgroundSize: "cover" }}
                                ref={backgroundCardMeli}>
                                <input
                                    accept="image/*"
                                    className="d-none"
                                    type="file"
                                    onChange={(e) => { upload(e, backgroundCardMeli, "cardMeliPic") }}
                                    ref={picCardMeli}
                                />
                                <div className='row p-4 '>
                                    <div className='col justify-content-center align-items-center text-center' >
                                        <div>
                                            <Link
                                                to=""
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    picCardMeli.current.click()
                                                }}>
                                                <img src={AddImage} />
                                            </Link>
                                        </div>
                                        تصویر کارت ملی
                                    </div>
                                </div>
                            </div>
                            <div className='col-auto border rounded m-2   '
                                style={{ backgroundSize: "cover" }}
                                ref={backgroundCode}>
                                <input
                                    accept="image/*"
                                    className="d-none"
                                    type="file"
                                    onChange={(e) => { upload(e, backgroundCode, "codePic") }}
                                    ref={picCode}
                                />
                                <div className='row p-4 '>
                                    <div className='col justify-content-center align-items-center text-center' >
                                        <div>
                                            <Link
                                                to=""
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    picCode.current.click()
                                                }}>
                                                <img src={AddImage} />
                                            </Link>
                                        </div>
                                        تصویر شناسنامه
                                    </div>
                                </div>
                            </div>
                            <div className='col-auto border rounded m-2   '
                                style={{ backgroundSize: "cover" }}
                                ref={backgroundMovafegh}>
                                <input
                                    accept="image/*"
                                    className="d-none"
                                    type="file"
                                    onChange={(e) => { upload(e, backgroundMovafegh, "movafeghPic") }}
                                    ref={picMovafegh}
                                />
                                <div className='row p-4 '>
                                    <div className='col justify-content-center align-items-center text-center' >
                                        <div>
                                            <Link
                                                to=""
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    picMovafegh.current.click()
                                                }}>
                                                <img src={AddImage} />
                                            </Link>
                                        </div>
                                        تصویر حکم بازنشستگی
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row">
                            <div className="col">
                                <div className=" d-flex justify-content-center">
                                    <button
                                        className="btn w-50 rounded-pill btn-primary "
                                        onClick={handlePosting}
                                        disabled={isPosting}>
                                        ثبت
                                        {isPosting &&
                                            <div className="spinner-border spinner-border-sm" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row mt-4 mb-4 ">
                        <div className="col d-flex  justify-content-center">
                            <Link to="/login" ><img src={logoNoronCar} className="img-fluid rounded-circle iconLink mx-2 shadow" alt="logoWeb" />بازگشت</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );

}
